import withLightbox from "../hoc/wihtLigthBox";
import Lightbox from "../view/components/plugins/LightBox";

export default withLightbox(Lightbox);